import { Button, Dialog, LinearProgress } from '@mui/material'
import Grid2 from '@mui/material/Unstable_Grid2'
import React, { useState } from 'react'

function TeacherSubjects({handleClose, open, syllabusData, onSyllabusSelect, loading, grades,subjects, teacherSubscriptions, onClickOnSubject}) {
    // console.log(subjects)
    // console.log(teacherSubscriptions)

    const [selectedGrade, setSelectedGrade] = useState(null)
    const filteredSubjects = selectedGrade ? subjects.filter(subject => {
        const {subjectGrade} = subject;
        if (!subjectGrade || !subjectGrade.id) { return false; }
        return subjectGrade.id === selectedGrade.id;
    }) : subjects;

    const onGradeSelect = (grade) => {
        setSelectedGrade(grade);
        // console.log("Selected Grade:", grade);
    }

  return (
    <Dialog onClose={handleClose} open={open} fullWidth maxWidth="lg">
      {loading && <LinearProgress />}
      <Grid2 container spacing={2} sx={{ padding: "20px" }}>
        <Grid2 xs={12} md={4}>
          {syllabusData.map((syllabus, index) => (
            <div key={index}>
              <Button
                variant="outlined"
                color="primary"
                fullWidth
                sx={{ marginBottom: "10px" }}
                onClick={() => onSyllabusSelect(syllabus)}
              >
                {syllabus.name}
              </Button>
            </div>
          ))}
        </Grid2>
        <Grid2 xs={12} md={3}>
          {grades.map((grade, index) => {
            const gradeName = grade.nameTags[0]?.name;
            return (
              <Button
                variant="outlined"
                color={selectedGrade && selectedGrade.id == grade.id ?   "primary" : "secondary"}
                fullWidth
                sx={{ marginBottom: "10px" }}
                key={index}
                onClick={() => onGradeSelect(grade)}
              >
                {gradeName}
              </Button>
            );
          })}
        </Grid2>

        <Grid2 xs={12} md={4}>
            {
                filteredSubjects.map((subject, index) => {
                    const isSelected =  teacherSubscriptions.find(subscription => subscription.subject.id === subject.id);
                    return (
                    <Button
                    variant="outlined"
                    color={isSelected ?  "secondary" : "primary"}
                    fullWidth
                    sx={{ marginBottom: "10px" }}
                    key={index}
                    onClick={() => {
                        // Handle subject selection logic here
                        onClickOnSubject(subject, isSelected);
                    }}
                    >
                    {subject.name}
                    </Button>
                )})
            }
        </Grid2>
      </Grid2>
    </Dialog>
  );
}

export default TeacherSubjects